import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "searchresult-area" }
const _hoisted_2 = { class: "result-controller flex items-center justify-between" }
const _hoisted_3 = { class: "all-check-wrapper flex items-center" }
const _hoisted_4 = {
  key: 0,
  style: {"font-weight":"normal"}
}
const _hoisted_5 = { class: "q-gutter-sm" }
const _hoisted_6 = { class: "left-area" }
const _hoisted_7 = { class: "flex items-center query-data" }
const _hoisted_8 = {
  key: 0,
  class: "img-container emphable-img"
}
const _hoisted_9 = {
  key: 1,
  class: "query-container"
}
const _hoisted_10 = { class: "right-area flex" }
const _hoisted_11 = {
  key: 0,
  class: "result-wrapper search-result-none linkable"
}
const _hoisted_12 = {
  key: 1,
  class: "result-wrapper search-result-none"
}
const _hoisted_13 = {
  key: 2,
  class: "result-wrapper search-result-none linkable"
}

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;
import saveAs from 'file-saver';
import ChemCard from '../card/ChemCard.vue';
import AtomImage from '../images/AtomImage.vue';
import AlertDialog from '../dialogs/AlertDialog.vue';
import http from '../../common/axios-common';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import DetailResultDialog from '../dialogs/DetailResultDialog.vue';
import base64toBlob from '../../common/utils/fileUtils';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';

// 検索結果
interface Result {
  atto_id: string;
  atto_supplier_count: number;
  order_count: number;
  condition_id: number;
  result_id: number;
  result_number: number;
  structure: string;
}

// 検索条件
interface Conditions {
  condition_id: number;
  condition_number: number;
  symbolic_query: string;
  symbolic_query_type: string;
  querysearchResultCount: number;
}

// 検索結果情報
interface SearchResultInfo {
  searchResultConditionsDto: Conditions;
  searchResultDetailList: Array<Result>;
}

// 検索Response
interface SearchResponse {
  attoIdList: Array<string>;
  searchResultInfo: Array<SearchResultInfo>;
  searchMaxCount: number;
}

// サプライヤInterface
interface Supplier {
  label: string;
  value: string;
}

interface Props {
  // 検索結果
  searchResult: SearchResponse;
  // 試薬フラグ
  reagentFlg: boolean;
  // カテゴリー
  categories: number[];
  // サプライヤ
  suppliers: Supplier[];
}

export default /*@__PURE__*/_defineComponent({
  __name: 'SearchResultList',
  props: {
    searchResult: {},
    reagentFlg: { type: Boolean },
    categories: {},
    suppliers: {}
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();

// ダイアログ表示
const dialogDispFlg = ref<boolean>(false);

// ダイアログテキスト
const dialogText = ref<Array<string>>(['']);

// ダイアログタイトル
const dialogTitle = ref<string>('');

// Dialog表示レベル
const dialogLevel = ref('');

// 確認Dialogフラグ
const isConfFlg = ref(false);

// Sdf出力確認Dialog表示フラグ
const isOutSdfDialog = ref(false);

// Excel出力確認Dialog表示フラグ
const isOutExcelDialog = ref(false);

// チェックボックス選択値
const checkValues = ref<Array<string>>([]);

// チェックボックス全選択フラグ
const checked = ref<boolean>(false);

// 詳細結果の表示フラグ
const detailResultDialogFlg = ref(false);

// 詳細結果に表示するATTOID
const selectAttoId = ref<string>('');

// チェックボックス変更処理
const changeCheckBox = (attoIdList: Array<string>) => {
  if (JSON.stringify(props.searchResult.attoIdList) === JSON.stringify(attoIdList.sort())) {
    checked.value = true;
  } else {
    checked.value = false;
  }
  checkValues.value = attoIdList;
};

// Excel出力確認ダイアログ表示
const displayOutExcelDialog = () => {
  // チェックボックスが1つもチェックされていない場合
  if (checkValues.value.length === 0) {
    dialogText.value = ['出力対象を選択してください。'];
    dialogTitle.value = 'Excel出力エラー';
    dialogDispFlg.value = true;
    isOutExcelDialog.value = false;
  } else {
    dialogTitle.value = 'Excel出力確認';
    dialogLevel.value = 'information';
    dialogText.value = ['検索結果のExcelファイルを出力します。', 'よろしいですか？'];
    isConfFlg.value = false;
    isOutExcelDialog.value = true;
  }
};

// SDF出力確認ダイアログ表示
const displayOutSdfDialog = () => {
  // チェックボックスが1つもチェックされていない場合
  if (checkValues.value.length === 0) {
    dialogText.value = ['出力対象を選択してください。'];
    dialogTitle.value = 'SDFile出力エラー';
    dialogDispFlg.value = true;
    isOutSdfDialog.value = false;
  } else {
    dialogTitle.value = 'SDFile出力確認';
    dialogLevel.value = 'information';
    dialogText.value = ['検索結果のSDFileを出力します。', 'よろしいですか？'];
    isConfFlg.value = false;
    isOutSdfDialog.value = true;
  }
};

// Excelダウンロード
const downloadExcel = () => {
  // チェックボックスが1つもチェックされていない場合
  if (checkValues.value.length === 0) {
    dialogText.value = ['出力対象を選択してください。'];
    dialogTitle.value = 'Excel出力エラー';
    dialogDispFlg.value = true;
    isOutExcelDialog.value = false;
  } else {
    // Loading Start
    Loading.show();

    const formData = new FormData();
    checkValues.value.forEach((attoId: string) => formData.append('atto_ids', attoId));
    formData.append('filetype', 'XLSX');

    // ダウンロード
    http
      .post('/search-result/download', formData)
      .then((response) => {
        if (response.data.common.status === ResultStatusCode.ERROR) {
          router.push({ name: 'error' });
        } else {
          const blob = new Blob(
            [
              base64toBlob(
                response.data.body,
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              ),
            ],
            {}
          );
          saveAs(blob, response.data.file_name);
          // ダイアログ表示
          dialogTitle.value = 'Excel出力完了';
          dialogLevel.value = 'information';
          dialogText.value = ['検索結果のExcelファイルを出力しました。'];
          isConfFlg.value = true;
          isOutExcelDialog.value = true;
        }
      })
      .catch((err) => {
        if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
          // セッションタイムアウトの場合
          router.push({ name: 'login', query: { timeout: 'timeout' } });
        } else {
          // その他のエラーの場合
          //  エラー画面に遷移
          router.push({ name: 'error' });
        }
      })
      .finally(() => {
        // Loading End
        Loading.hide();
      });
  }
};

// SDFダウンロード
const downloadSdf = () => {
  // チェックボックスが1つもチェックされていない場合
  if (checkValues.value.length === 0) {
    dialogText.value = ['出力対象を選択してください。'];
    dialogTitle.value = 'SDFile出力エラー';
    dialogDispFlg.value = true;
    isOutSdfDialog.value = false;
  } else {
    // Loading Start
    Loading.show();

    const formData = new FormData();
    checkValues.value.forEach((attoId: string) => formData.append('atto_ids', attoId));
    formData.append('filetype', 'SDF');

    // ダウンロード
    http
      .post('/search-result/download', formData)
      .then((response) => {
        if (response.data.common.status === ResultStatusCode.ERROR) {
          router.push({ name: 'error' });
        } else {
          const blob = new Blob([base64toBlob(response.data.body, 'text/plain')], {});
          saveAs(blob, response.data.file_name);
          // ダイアログ表示
          dialogTitle.value = 'SDFile出力完了';
          dialogLevel.value = 'information';
          dialogText.value = ['検索結果のSDFileを出力しました。'];
          isConfFlg.value = true;
          isOutSdfDialog.value = true;
        }
      })
      .catch((err) => {
        if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
          // セッションタイムアウトの場合
          router.push({ name: 'login', query: { timeout: 'timeout' } });
        } else {
          // その他のエラーの場合
          //  エラー画面に遷移
          router.push({ name: 'error' });
        }
      })
      .finally(() => {
        // Loading End
        Loading.hide();
      });
  }
};

// 詳細ボタン押下
const onDetail = (attoId: string) => {
  selectAttoId.value = attoId;
  detailResultDialogFlg.value = true;
};

return (_ctx: any,_cache: any) => {
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (props.searchResult.attoIdList.length !== 0)
          ? (_openBlock(), _createBlock(_component_q_checkbox, {
              key: 0,
              modelValue: checked.value,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((checked).value = $event)),
                _cache[1] || (_cache[1] = 
            (value) => (value ? (checkValues.value = props.searchResult.attoIdList) : (checkValues.value = []))
          )
              ],
              color: "primary"
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createElementVNode("p", null, [
          _createElementVNode("span", null, _toDisplayString(props.searchResult.attoIdList.length), 1),
          _cache[11] || (_cache[11] = _createTextVNode("件 ")),
          (props.searchResult.searchMaxCount > Number(_ctx.$t('validation.search_max_count')))
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "/ " + _toDisplayString(props.searchResult.searchMaxCount) + "件", 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (props.searchResult.attoIdList.length !== 0)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              icon: "mdi-download",
              class: "export-btn",
              color: "primary",
              outline: "",
              "no-caps": "",
              onClick: displayOutExcelDialog
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("Excel出力")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        (props.searchResult.attoIdList.length !== 0)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 1,
              icon: "mdi-download",
              color: "primary",
              outline: "",
              "no-caps": "",
              class: "export-btn",
              onClick: displayOutSdfDialog
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [
                _createTextVNode("SDFile出力")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_q_list, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.searchResult.searchResultInfo, (item, i) => {
          return (_openBlock(), _createBlock(_component_q_item, {
            key: i,
            class: "mb-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, { class: "flex justify-between" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "result-title" }, "【検索条件】", -1)),
                    _createElementVNode("div", _hoisted_7, [
                      (item.searchResultConditionsDto.symbolic_query_type === 'STRUCTURE')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createVNode(AtomImage, {
                              exatoms: item.searchResultConditionsDto.symbolic_query
                            }, null, 8, ["exatoms"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("p", null, _toDisplayString(item.searchResultConditionsDto.symbolic_query), 1)
                          ]))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (item.searchResultConditionsDto.querysearchResultCount === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _cache[18] || (_cache[18] = _createElementVNode("div", null, "検索条件に該当する商品はありませんでした。", -1)),
                          _createElementVNode("div", null, [
                            _cache[16] || (_cache[16] = _createTextVNode(" 検索結果にご不明な点がございましたら、 ")),
                            _createVNode(_component_router_link, {
                              to: { name: 'inquiry' },
                              class: "text-link"
                            }, {
                              default: _withCtx(() => _cache[15] || (_cache[15] = [
                                _createTextVNode("お問い合わせ")
                              ])),
                              _: 1
                            }),
                            _cache[17] || (_cache[17] = _createTextVNode("ください。 "))
                          ])
                        ]))
                      : (
                item.searchResultConditionsDto.querysearchResultCount !== 0 &&
                item.searchResultDetailList === null
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[19] || (_cache[19] = [
                            _createElementVNode("p", null, "検索結果が他の条件で上限数を超えたため、検索しませんでした。", -1),
                            _createElementVNode("p", null, "当条件のみで検索を実施してください。", -1)
                          ])))
                        : (
                item.searchResultConditionsDto.querysearchResultCount === null &&
                item.searchResultDetailList.length === 0
              )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _cache[23] || (_cache[23] = _createElementVNode("div", null, "検索条件に該当する商品はありませんでした。", -1)),
                              _createElementVNode("div", null, [
                                _cache[21] || (_cache[21] = _createTextVNode(" 検索結果にご不明な点がございましたら、 ")),
                                _createVNode(_component_router_link, {
                                  to: { name: 'inquiry' },
                                  class: "text-link"
                                }, {
                                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                                    _createTextVNode("お問い合わせ")
                                  ])),
                                  _: 1
                                }),
                                _cache[22] || (_cache[22] = _createTextVNode("ください。 "))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.searchResultDetailList, (itemDetail, itd) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: itd,
                        class: "result-wrapper"
                      }, [
                        _createVNode(ChemCard, {
                          "check-values": checkValues.value,
                          result: itemDetail,
                          onChangeCheck: changeCheckBox,
                          onOnDetail: onDetail
                        }, null, 8, ["check-values", "result"])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(AlertDialog, {
      display: isOutExcelDialog.value,
      level: dialogLevel.value,
      confirmation: isConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[2] || (_cache[2] = ($event: any) => (isOutExcelDialog.value = false)),
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => (downloadExcel())),
      onClose: _cache[4] || (_cache[4] = ($event: any) => (isOutExcelDialog.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"]),
    _createVNode(AlertDialog, {
      display: isOutSdfDialog.value,
      level: dialogLevel.value,
      confirmation: isConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[5] || (_cache[5] = ($event: any) => (isOutSdfDialog.value = false)),
      onConfirm: _cache[6] || (_cache[6] = ($event: any) => (downloadSdf())),
      onClose: _cache[7] || (_cache[7] = ($event: any) => (isOutSdfDialog.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"]),
    (detailResultDialogFlg.value)
      ? (_openBlock(), _createBlock(DetailResultDialog, {
          key: 0,
          "result-atto-id-list": props.searchResult.attoIdList,
          "select-atto-id": selectAttoId.value,
          "detail-result-flg": detailResultDialogFlg.value,
          "reagent-flg": props.reagentFlg,
          categories: props.categories,
          suppliers: props.suppliers,
          onCloseDetailDialog: _cache[8] || (_cache[8] = ($event: any) => (detailResultDialogFlg.value = false)),
          onDetailResultDialogFlg: _cache[9] || (_cache[9] = ($event: any) => (detailResultDialogFlg.value = $event))
        }, null, 8, ["result-atto-id-list", "select-atto-id", "detail-result-flg", "reagent-flg", "categories", "suppliers"]))
      : _createCommentVNode("", true),
    _createVNode(AlertDialog, {
      display: dialogDispFlg.value,
      level: "error",
      confirmation: "",
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[10] || (_cache[10] = ($event: any) => (dialogDispFlg.value = false))
    }, null, 8, ["display", "title", "text"])
  ]))
}
}

})